<template>
  <a-modal v-model="visible" :centered="true" :confirmLoading="loading" :destroyOnClose="destroyOnClose" :title="$t('title.inboundScan')" width="40%" @cancel="handleCancel" @ok="handleOk">
    <a-spin :spinning="loading">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item :label="$t('business.label.containerNo')">
          <span>{{ view.container.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.sourceLocation')">
          <span>{{ view.sourceLocation.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.targetStorageRoom')">
          <a-input-search v-model="view.storageRoom.name" class="query" @dblclick="searchStorageRoom()" @pressEnter="searchStorageRoom()" @search="searchStorageRoom()"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.targetLocation')">
          <a-input-search v-model="view.targetLocation.no" class="query" @dblclick="searchLocation()" @pressEnter="searchLocation()" @search="searchLocation()" />
        </a-descriptions-item>
      </a-descriptions>
      <storage-room-modal ref="storageRoomModal" @change="(rlt)=>selectStorageRoom(rlt[0])"/>
      <location-modal ref="locationModal" @change="(rlt)=>selectLocation(rlt[0])"/>
    </a-spin>
  </a-modal>
</template>

<script>
import { post } from '@/api/Api'
import Api from '@/api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import { ContainerCommand } from '@/api/dto/command/ContainerCommand'
import { Container } from '@/api/dto/common/Container'
import { Location } from '@/api/dto/common/Location'
import { StorageRoom } from '@/api/dto/common/StorageRoom'

export default {
    name: 'InboundScan',
    components: { LocationModal, StorageRoomModal },
    data() {
      return {
        visible: false,
        loading: false,
        destroyOnClose: true,
        view: new ContainerCommand()
      }
    },
    methods: {
      open(args) {
        if (args) {
          this.view.container = new Container(args.container)
          if (args.sourceLocation) {
            this.view.sourceLocation = new Location(args.sourceLocation)
          }
          if (args.targetLocation) {
            this.view.targetLocation = new Location(args.targetLocation)
          }
          if (args.storageRoom) {
            this.view.storageRoom = new StorageRoom(args.storageRoom)
          }
          this.visible = true
        }
      },
      handleOk() {
        this.loading = true
        const args = {
          'container.no': this.view.container.no,
          'location.no': this.view.targetLocation.no,
          storageRoomType: this.view.storageRoom.storageRoomType,
          tag: this.view.storageRoom.tag
        }
        post(Api.containerScanAll, { type: 'generalHandler' }, args).then(res => {
          if (res.success) {
            this.$emit('success')
            let that = this
            this.$success({
              title: '入库扫描成功',
              onOk() {
                that.handleCancel()
              },
              okText: '确定',
              centered: true
            })
          }
        }).finally(() => this.loading = false)
      },
      handleCancel() {
        this.visible = false
      },
      searchStorageRoom() {
        this.$refs.storageRoomModal.open()
      },
      selectStorageRoom(record) {
        this.view.storageRoom = new StorageRoom(record)
        this.view.targetLocation = new Location()
      },
      searchLocation() {
        if (this.view.storageRoom.isNew()) {
          return this.$warning({
            title: '目的库房为空',
            content: '请选择目的库房',
            centered: true,
            okText: '确定'
          })
        }
        this.$refs.locationModal.open({ 'storageRoom.id': this.view.storageRoom.id })
      },
      selectLocation(record) {
        this.view.targetLocation = new Location(record)
      }
    }
  }
</script>